import { all } from 'redux-saga/effects';
import { activitySagas } from './activitySagas';
import { atpSagas } from './AdaptiveTrainingPlans/atpSagas';
import { atpFeedSagas } from './atpFeedSagas';
import { atpContentFulSaga } from './atpContentFulSagas';
import { loadContentFulVideo } from './atpVideoContentSaga';
import { systemSagas } from './systemSagas';
import { workoutSaga } from './workoutSaga';
import { golfStatsSagas } from './golfStatsSagas';
import { golfClubSagas } from './golfClubSagas';
import { gdprSagas } from './gdprSagas';
import { userPreferenceSagas } from './userPreferenceSagas';
import { fitnessStatsSagas } from './fitnessStatsSagas';
import { pulseOxAcclimationSagas } from './pulseOxAcclimationSagas';
import { dailySummarySagas } from './dailySummarySagas';
import { heartRateZonesSagas } from './heartRateZoneSagas';
import { powerZonesSagas } from './powerZonesSagas';
import { moveIQSagas } from './moveIQSagas';
import { deviceSagas } from './deviceSagas';
import { segmentSagas } from './segmentSagas';
import { hydrationSagas } from './hydrationSagas';
import { viewerUserPreferencesSagas } from './viewerUserPreferencesSaga';
import { userSettingsSagas } from './userSettingsSagas';
import { userStatsSagas } from './userStatsSagas';
import { userSummarySagas } from './userSummarySagas';
import { stravaSagas } from './stravaSagas';
import { insightsSagas } from './insightsSagas';
import { stepsLifetimeTotalsSagas } from './stepsLifetimeTotalsSagas';
import { courseSagas } from './courseSagas';
import { mfpSagas } from './mfpSagas';
import { paceProBand } from './paceProBandSagas';
import { menstrualCycleTrackingSagas } from './menstrualCycleTrackingSagas';
import { workoutExecutionSagas } from './workoutExecutionSagas';
import { workoutTypesSagas } from './workoutTypesSagas';
import { userCapableSagas } from './userCapableSagas';
import { weightSagas } from './weightSagas';
import { dailyPulseOxSagas } from './dailyPulseOxSagas';
import { dailyRespirationSagas } from './dailyRespirationSagas';
import { respirationReportsSagas } from './dailyRespirationSagas';
import { paceProAlgorithmSagas } from './paceProAlgorithmSagas';
import { personalRecordsSagas } from './personalRecordsSagas';
import { pregnancyTrackingSagas } from './pregnancyTrackingSagas';
import { wellnessGoalSagas } from './wellnessGoalSagas';
import { golfCourse } from './golfCourseSagas';
import { golfCourses } from './golfCoursesSagas';
import { golfCourseStats } from './golfCourseStatsSagas';
import { golfCourseLayouts } from './golfCourseLayoutSagas';
import { sleepSagas } from 'sagas/sleepSagas';
import { solarIntensity } from './solarIntensitySagas';
import { trainingStatusSagas } from './trainingStatusSagas';
import { phasedTrainingPlanSagas } from './PhasedTrainingPlan/phasedTrainingPlanSagas';
import { powerGuidanceSagas } from './PowerGuidance/powerGuidanceSagas';
import { userPrivacySagas } from './UserPrivacy/userPrivacy';
import { climbDifficulties } from './climbDifficultiesSaga';
import { intensityMinutesSagas } from './intensityMinutesSagas';
import { activityDetailsSagas } from './activityDetailsSagas';
import { activityMapDetailsSagas } from './activityMapDetailsSagas';
import { challenge } from 'sagas/challengeSagas';
import { epochDataReloadSagas } from './epochDataReloadSagas';
import { bloodPressureSagas } from 'sagas/bloodPressure';
import { fitnessAgeSagas } from './fitnessAgeSagas';
import { ftpSagas } from './ftp';
import { ftpRangeSagas } from './ftpRange';
import { typedSplits } from './activityTypedSplits';
import { benchmarkExercisesSagas } from './benchmarkExercisesSagas';
import { exerciseTypesSagas } from './exerciseTypesSagas';
import { exerciseEquipmentsSagas } from './exerciseEquipmentsSagas';
import { exerciseSagas } from './exercisesSagas';
import { golfProfile } from './golfProfileSagas';
import { timezoneUnits } from './timezoneSaga';
import { shareableEvent } from './shareableEventSaga';
import { muscleMappingModelSagas } from './muscleMappingModelSagas';
import { workoutsSagas } from './workoutsSagas';
import { golfScorecardSummary } from './golfScorecardSagas';
import { reportExportSagas } from './reportExportSagas';
import { healthSnapshotSagas } from './healthSnapshotSagas';
import { powerBenchmarksSagas } from './powerBenchmarksSagas';
import { conversationLikesSagas } from './conversationLikesSagas';
import { groupConversationLikesSagas } from './groupConversationLikesSagas';
import { newsFeedSagas } from './newsFeedSagas';
import { leaderboardSagas } from './leaderboardSagas';
import { notificationSagas } from './notificationSagas';
import { multiSportEditSagas } from './multiSportEditSagas';
import { ecgRecordingSagas } from './ecgRecordingSagas';
import { eventGoals } from './eventGoalsSagas';
import { stepsReportsSagas } from './stepsReportsSagas';
import { pushesReportsSagas } from './pushesReportsSagas';
import { badgeSagas } from './badgeSagas';
import { userProfileSagas } from './userProfileSagas';
import { blockUserSagas } from './blockUserSagas';
import { floorsDataSaga } from './floorsDataSaga';
import { floorsReportDataSaga } from './floorsReportDataSaga';
import { totalCaloriesSagas } from './totalCaloriesSagas';
import { trainingReadinessSagas } from './trainingReadinessSagas';
import { hrvStatusSagas } from './hrvStatusSagas';
import { calendarSagas } from './calendarSagas';
import { mutualConnectionsSagas } from './mutualConnectionsSagas';
import { hydrationReportsSagas } from './hydrationReportsSagas';
import { stressReportsSagas } from './stressReportsSagas';
import { demographicSelectionsSagas } from './demographicSelectionsSagas';
import { activitiesSagas } from './activitiesSagas';
import { mapSagas } from './mapSagas';
import { groupSagas } from './groupSagas';
import { groupPageSagas } from './groupPageSagas';
import { groupPageLeaderboardSagas } from './groupPageLeaderboardSagas';
import { groupPageInviteSagas } from './groupPageInviteSagas';
import { groupPageCourseSagas } from './groupPageCourseSagas';
import { groupPageReportPhotoDialogSagas } from './groupPageReportPhotoDialogSagas';
import { demographicCompareSagas } from './demographicCompareSagas';
import { demographicComparePreferencesSagas } from './demographicComparePreferencesSagas';
import { connectionSagas } from './connectionSagas';
import { heartRateReportDataSaga } from './heartRateReportSaga';
import { sleepReportsSagas } from './sleepReportsSagas';
import { userSocialProfileSagas } from './userSocialProfileSagas';
import { usageIndicatorsSagas } from './usageIndicatorsSagas';
import { jetLagSagas } from './jetLagSagas';
import { cssReportsSagas } from './criticalSwimSpeedSagas';
import { gearsSagas } from './gearsSagas';
import { challengePageSagas } from './challengePageSagas';
import { bodyBatterySagas } from './bodyBatterySagas';
import { inboxPageSagas } from './inboxPageSagas';
import { deviceBackupSagas } from './deviceBackupSagas';
import { sleepReportSagas } from './sleepReportSagas';
import { sleepDailySagas } from './sleepDailySagas';
import { emailNotificationSagas } from './emailNotificationSagas';
import { lactateThresholdSagas } from './lactateThresholdSagas';
import { climbSagas } from './climbSagas';
import { currentUserInfoSagas } from './currentUserInfoSagas';
import { thirdPartyAppsSagas } from './thirdPartyAppsSagas';
import { hillScoreReportsSagas } from './hillScoreReportsSagas';
import { optionalFeatureSagas } from './optionalFeatureSagas';
import { vo2MaxMetricsSagas } from './vo2MaxMetricsSagas';
import { enduranceScoreReportsSagas } from './enduranceScoreReportsSagas';
import { createChallengePageSagas } from './createChallengePageSagas';
import { golfPlayerShots } from './golfPlayerShotsSagas';
import { golfHistoricalShots } from './golfHistoricalShotsSagas';
import { trainingPlanIntegrationSagas } from './trainingPlanIntegrationSagas';
import { ftbAdaptiveCoachingTrainingPlanSagas } from './ftbAdaptiveCoachingTrainingPlanSagas';
import { golfLeaderboard } from './golfLeaderboardSagas';
import { userProfileBaseSagas } from './userProfileBaseSagas';
import { hazardsSagas } from './hazardsSagas';
import { socialGroupRideSagas } from './socialGroupRideSagas';
import { imagePathsSagas } from './imagePathsSagas';
import { userSocialProfileImageSagas } from './userSocialProfileImageSagas';
import { triathlonTypes } from './eventsSagas';

export default function* rootSaga() {
    yield all([
        ...activitySagas,
        ...atpSagas,
        ...atpFeedSagas,
        ...atpContentFulSaga,
        ...loadContentFulVideo,
        ...systemSagas,
        ...workoutSaga,
        ...golfStatsSagas,
        ...golfClubSagas,
        ...gdprSagas,
        ...userPreferenceSagas,
        ...fitnessStatsSagas,
        ...pulseOxAcclimationSagas,
        ...dailySummarySagas,
        ...heartRateZonesSagas,
        ...powerZonesSagas,
        ...moveIQSagas,
        ...deviceSagas,
        ...segmentSagas,
        ...hydrationSagas,
        ...viewerUserPreferencesSagas,
        ...userSettingsSagas,
        ...userStatsSagas,
        ...userSummarySagas,
        ...stravaSagas,
        ...insightsSagas,
        ...stepsLifetimeTotalsSagas,
        ...courseSagas,
        ...mfpSagas,
        ...paceProBand,
        ...menstrualCycleTrackingSagas,
        ...workoutExecutionSagas,
        ...userCapableSagas,
        ...weightSagas,
        ...dailyPulseOxSagas,
        ...dailyRespirationSagas,
        ...respirationReportsSagas,
        ...paceProAlgorithmSagas,
        ...personalRecordsSagas,
        ...powerBenchmarksSagas,
        ...pregnancyTrackingSagas,
        ...wellnessGoalSagas,
        ...golfCourse,
        ...golfCourses,
        ...golfCourseStats,
        ...golfCourseLayouts,
        ...solarIntensity,
        ...sleepSagas,
        ...trainingStatusSagas,
        ...phasedTrainingPlanSagas,
        ...powerGuidanceSagas,
        ...userPrivacySagas,
        ...climbDifficulties,
        ...activityDetailsSagas,
        ...activityMapDetailsSagas,
        ...challenge,
        ...intensityMinutesSagas,
        ...epochDataReloadSagas,
        ...bloodPressureSagas,
        ...epochDataReloadSagas,
        ...fitnessAgeSagas,
        ...ftpSagas,
        ...ftpRangeSagas,
        ...typedSplits,
        ...benchmarkExercisesSagas,
        ...exerciseTypesSagas,
        ...exerciseEquipmentsSagas,
        ...exerciseSagas,
        ...golfProfile,
        ...workoutTypesSagas,
        ...timezoneUnits,
        ...shareableEvent,
        ...muscleMappingModelSagas,
        ...workoutsSagas,
        ...golfScorecardSummary,
        ...reportExportSagas,
        ...healthSnapshotSagas,
        ...conversationLikesSagas,
        ...groupConversationLikesSagas,
        ...newsFeedSagas,
        ...leaderboardSagas,
        ...notificationSagas,
        ...multiSportEditSagas,
        ...ecgRecordingSagas,
        ...trainingReadinessSagas,
        ...eventGoals,
        ...stepsReportsSagas,
        ...pushesReportsSagas,
        ...floorsDataSaga,
        ...floorsReportDataSaga,
        ...totalCaloriesSagas,
        ...hydrationReportsSagas,
        ...stressReportsSagas,
        ...heartRateReportDataSaga,
        ...sleepReportsSagas,
        ...badgeSagas,
        ...userProfileSagas,
        ...blockUserSagas,
        ...hrvStatusSagas,
        ...calendarSagas,
        ...mutualConnectionsSagas,
        ...demographicSelectionsSagas,
        ...activitiesSagas,
        ...mapSagas,
        ...groupSagas,
        ...groupPageSagas,
        ...groupPageLeaderboardSagas,
        ...groupPageInviteSagas,
        ...groupPageCourseSagas,
        ...groupPageReportPhotoDialogSagas,
        ...demographicCompareSagas,
        ...demographicComparePreferencesSagas,
        ...connectionSagas,
        ...userSocialProfileSagas,
        ...usageIndicatorsSagas,
        ...jetLagSagas,
        ...cssReportsSagas,
        ...gearsSagas,
        ...challengePageSagas,
        ...bodyBatterySagas,
        ...inboxPageSagas,
        ...emailNotificationSagas,
        ...lactateThresholdSagas,
        ...deviceBackupSagas,
        ...sleepReportSagas,
        ...sleepDailySagas,
        ...emailNotificationSagas,
        ...climbSagas,
        ...currentUserInfoSagas,
        ...thirdPartyAppsSagas,
        ...hillScoreReportsSagas,
        ...optionalFeatureSagas,
        ...vo2MaxMetricsSagas,
        ...enduranceScoreReportsSagas,
        ...createChallengePageSagas,
        ...golfPlayerShots,
        ...golfHistoricalShots,
        ...trainingPlanIntegrationSagas,
        ...ftbAdaptiveCoachingTrainingPlanSagas,
        ...golfLeaderboard,
        ...userProfileBaseSagas,
        ...hazardsSagas,
        ...socialGroupRideSagas,
        ...imagePathsSagas,
        ...userSocialProfileImageSagas,
        ...triathlonTypes
    ]);
}
